// TODO: Make it more generic, even if the menu is not inside a single container
let headerFocusable = document.querySelectorAll(
  '#hoas-header button, #hoas-header [href], #hoas-header input, #hoas-header select, #hoas-header textarea, #hoas-header [tabindex]:not([tabindex="-1"])',
);
let firstHeaderFocusable = headerFocusable[0];
let mobile_menu_links = document.querySelectorAll(".mobile-menu-content a");
